<template>
  <div class="headBox">
    <div class="content search">
      <div class="logo" @click="$router.push('/index')">
        <img src="/static/image/newLogo.png" />
        <div class="line"></div>
        <div class="logo-des">
          <p>消费帮促</p>
          <p>采购平台</p>
        </div>
      </div>
      <div class="search-box">
        <div>
          <img
            src="../../../static/image/search.svg"
            alt=""
            class="search-icon"
          />
          <input
            class="search-input"
            type="text"
            placeholder="请输入关键字"
            v-model="title"
            @keyup.enter="search()"
          />
          <button
            type="button"
            id="test"
            class="search-button"
            @click="search()"
          >
            搜索
          </button>
        </div>
        <!-- <div class="search-hot">
          <span>热门搜索：</span>
          <span>大米</span>
        </div> -->
      </div>
      <div class="textBox">
        <span
          ><span style="font-weight: 700">共同支持： </span
          ><span>江苏省委省级机关工委</span></span
        >
        <span style="margin-left: 85px">江苏省财政厅</span>

        <span style="margin-left: 85px">江苏省总工会</span>
        <!-- <span style="margin-left: 85px">江苏省乡村振兴局</span> -->
      </div>
    </div>
    <!--导航条-->
    <div class="content navbar">
      <div
        class="navbar-items"
        v-if="allDataObj.promotion && allDataObj.promotion.length > 0"
      >
        <span
          :class="[
            'navbar-text',
            $route.path == '/index' ? 'navbar-active' : ''
          ]"
          @click="$router.push('/index')"
          >关于我们</span
        >
        <span
          v-for="(item, index) in allDataObj.promotion"
          :key="index"
          :class="[
            'navbar-text',
            $route.fullPath == item.navigateUrl ? 'navbar-active' : ''
          ]"
          @click="gotoDetails(item.navigateUrl)"
          >{{ item.bannerTitle }}</span
        >
        <span
          :class="[
            'navbar-text',
            $route.fullPath == '/infoDetails?id=0' ? 'navbar-active' : ''
          ]"
          @click="$router.push('/infoDetails?id=0')"
          >产品展示</span
        >
        <span
          :class="[
            'navbar-text',
            $route.fullPath == '/infoDetails?id=29' ? 'navbar-active' : ''
          ]"
          @click="$router.push('/infoDetails?id=29')"
          >联系我们</span
        >
      </div>
    </div>
    <Dialog :dialogVisible="visible" @closepop="visible = false"> </Dialog>
  </div>
</template>

<script>
import { doPost, doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "./dialog.vue";

export default {
  props: {
    isShow: {
      type: Boolean, //可指定接收类型，如:Array.
      default: false //可设置默认值
    }
  },
  name: "topNav",
  components: {
    Dialog: dialog
  },
  data() {
    return {
      visible: false,
      userName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      name: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
      allDataObj: {},
      title: "", //搜索关键字
      shopCarNum: this.$store.state.shopCarNum, //购物车数量
      collectNum: this.$store.state.collectNum, //收藏夹数量
      chooseNav: 0 //选中的navBar
    };
  },
  watch: {
    "$store.state.shopCarNum"() {
      this.shopCarNum = this.$store.state.shopCarNum;
    },
    "$store.state.collectNum"() {
      this.collectNum = this.$store.state.collectNum;
    }
  },
  mounted() {
    console.log(this.$route);
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
    this.title = this.$route.query.title ? this.$route.query.title : "";
    let that = this;
    doPost(
      httpConfig.Index.InfoUrl,
      {},
      function(res) {
        that.allDataObj = that.distributeAllData(res);
      },
      function(res) {}
    );
  },
  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { peopleId: this.$cookies.get("peopleId"), type },
        function(res) {
          if (res.flag) {
            if (type == 0) {
              that.shopCarNum = 0;
              var shopCar = res.data;
              shopCar.forEach(item => {
                item.info = JSON.parse(item.info);
                that.shopCarNum += item.info.num; //计算购物车商品总数
              });
            } else {
              that.collectNum = res.data.length;
            }
          }
        },
        function(res) {}
      );
    },
    //解析所有数据
    distributeAllData(res) {
      var newData = {};
      for (var i = 0; i < res.length; i++) {
        newData[res[i].code] = res[i].banners;
      }
      return newData;
    },
    //跳转至商品列表
    gotoDetails(url) {
      this.$router.push(url);
    },
    //搜索
    search() {
      if (this.title.length == 0) {
        this.$router.push({ path: "/category" });
      } else {
        this.$router.push({ path: "/category", query: { title: this.title } });
      }
    },
    //退出登录
    logout() {
      var that = this;
      this.$confirm("确认退出登录？")
        .then(_ => {
          that.$cookies.remove("peopleId");
          // that.$cookies.remove("shopCar");
          // that.$cookies.remove("shopAddress");
          // that.$cookies.remove("collectList");
          that.$cookies.remove("userInfo");
          localStorage.removeItem("xfh_usertoken");
          // sessionStorage.clear();
          location.reload();
        })
        .catch(_ => {});
    }
  }
};
</script>

<style scoped>
.headBox {
  /* height: 236px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  /* border-bottom: 1px solid #F89A00; */
}
.header {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
}
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.smallHover {
  position: relative;
}
.smallHover:hover .smallImgBox {
  display: inline-block;
}
.smallImgBox {
  display: none;
  width: 200px;
  height: 200px;
  position: absolute;
  top: 40px;
  background-color: #fff;
  z-index: 100;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
.smallImgBox::before {
  content: "";
  width: 16px;
  height: 10px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid #fff;
  box-sizing: border-box;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: translate(-50%, 0);
}

.content {
  width: 1200px;
}

#nav {
  display: flex;
  height: 100%;
}

#nav > span {
  padding: 0 15px;
  cursor: pointer;
  line-height: 40px;
}

.search {
  margin-top: 36px;
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  /* margin-left: 20px; */
  cursor: pointer;
}

.logo img {
  /* width: 77px;
  height: 77px; */
  width: 161px;
  height: 64px;
  margin-right: 17px;
}
.line {
  width: 2px;
  height: 39px;
  background-color: #1a7c3d;
}
.logo .logo-des {
  /* margin-left: 12px; */
  margin-left: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo p {
  /* width: 80px; */
  /* height: 20px;
  font-size: 15px;
  font-family: PingFang, PingFang-Bold;
  font-weight: 700;
  color: #07811f;
  letter-spacing: 4px;
  margin: 0; */
  line-height: 28px;
  color: #1a7c3d;
  margin: 0;
  font-size: 22px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}

.logo p:last-child {
  margin-top: 6px;
}

.search-box {
  display: flex;
  /*align-items: center;*/
  flex-direction: column;
  /* margin-left: 220px; */
  margin-left: 130px;
}

.search-box div {
  position: relative;
}

.search-box .search-input {
  width: 419px;
  height: 40px;
  border: 3px solid #f89a00;
  border-radius: 10px;
  padding-left: 60px;
  outline: none;
  box-sizing: border-box;
}

.search-box .search-button {
  width: 100px;
  height: 40px;
  background-color: #f89a00;
  color: white;
  border: 0;
  position: absolute;
  right: 0;
  top: 0px;
  border-radius: 0 10px 10px 0;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  letter-spacing: 3px;
  cursor: pointer;
}
.search-box .search-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 17px;
  top: 50%;
  transform: translate(0, -50%);
}

.textBox {
  margin-left: 116px;
  /* height: 70px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  color: #1a7c3d;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 400;
}
.search-hot {
  margin-top: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #aaaaaa;
}
.search-hot span {
  margin-right: 15px;
}
.navbar {
  height: 40px;
  /* height: 0; */
  margin-top: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.category {
  width: 200px;
  height: 40px;
  background: #f89a00;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.category-title {
  font-size: 15px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
}
.category:hover .category-content {
  display: flex;
}
.category-content {
  /* padding-top: 1px; */
  width: 200px;
  position: absolute;
  left: 0;
  top: 40px;
  z-index: 9;
  background-color: white;
  display: none;
  flex-wrap: wrap;
}

.category-item {
  width: 200px;
  height: 66px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;

  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
}

.category-content .category-item {
  margin-bottom: 0.8px;
}

.category-content .category-item:last-child {
  margin: 0;
}

.navbar-items {
  /* margin-left: 201px; */
}

.navbar-text {
  font-size: 16px;
  font-family: PingFang, PingFang-Bold;
  font-weight: 700;
  color: #333333;
  cursor: pointer;
}
.navbar-active {
  color: #f89a00;
  border-bottom: 3px solid #f89a00;
}

.navbar-items :nth-child(n + 2) {
  margin-left: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue